/* eslint-disable react/no-array-index-key */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Box, Button, Checkbox, IconButton, Modal, Tooltip } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import CloseIcon from "@mui/icons-material/Close";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import { Vocabulary } from "../../Utils/Vocabulary";
import { CloudUpload } from "@mui/icons-material";
import DropzoneComponent from "./DropzoneComponent";
import styles from "../../Styles/showImages.module.css";
import { useEffect, useRef, useState } from "react";
import theme from "../../Themes/Theme";
import axios from "axios";
import { urlEnum } from "../../Utils/UrlEnum";

type AddAndShowImagesProps = {
  images: Array<any>;
  files: any;
  maxFiles?: number;
  checkedImages?: any;
  isSmall?: boolean;
  inline?: boolean;
  handleDeleteImages: (
    newImageList: any,
    newFileList: any,
    index: number
  ) => void;
  handleChangeFiles: (files: any) => void;
  displayDropzoneImages: (images: any) => void;
  handleCheckImages?: (index: number) => void;
};

export default function AddAndShowImages(props: AddAndShowImagesProps) {
  const {
    images,
    files,
    maxFiles,
    checkedImages,
    isSmall,
    inline,
    handleDeleteImages,
    handleChangeFiles,
    displayDropzoneImages,
    handleCheckImages,
  } = props;
  const [showDropzone, setShowDropzone] = useState<boolean>(false);
  const [dropzoneFiles, setDropzoneFiles] = useState<any>([]);
  const [imageData, setImageData] = useState<any>([]);
  const [shouldUpdate, setShouldUpdate] = useState(true);
  const [modalOpen, setModalOpen] = useState(false);
  const [modalIndex, setModalIndex] = useState(0);
  const [zoom, setZoom] = useState(1);
  const [pan, setPan] = useState({ x: 0, y: 0 });
  const dragging = useRef(false);
  const dragStart = useRef({ x: 0, y: 0 });
  const panAtDragStart = useRef({ x: 0, y: 0 });

  const ZOOM_STEP = 0.25;
  const ZOOM_MIN = 0.25;
  const ZOOM_MAX = 4;

  function resetView() { setZoom(1); setPan({ x: 0, y: 0 }); }
  function zoomIn()    { setZoom((z) => Math.min(z + ZOOM_STEP, ZOOM_MAX)); }
  function zoomOut()   { setZoom((z) => { const next = Math.max(z - ZOOM_STEP, ZOOM_MIN); if (next === 1) setPan({ x: 0, y: 0 }); return next; }); }

  function openModal(index: number) {
    setModalIndex(index);
    setZoom(1);
    setPan({ x: 0, y: 0 });
    setModalOpen(true);
  }

  useEffect(() => { setZoom(1); setPan({ x: 0, y: 0 }); }, [modalIndex]);

  function onMouseDown(e: React.MouseEvent) {
    if (zoom <= 1) return;
    dragging.current = true;
    dragStart.current = { x: e.clientX, y: e.clientY };
    panAtDragStart.current = pan;
    e.preventDefault();
  }

  function onMouseMove(e: React.MouseEvent) {
    if (!dragging.current) return;
    setPan({
      x: panAtDragStart.current.x + (e.clientX - dragStart.current.x),
      y: panAtDragStart.current.y + (e.clientY - dragStart.current.y),
    });
  }

  function onMouseUp() { dragging.current = false; }

  useEffect(() => {
    if (!modalOpen) return;
    function handleKeyDown(e: KeyboardEvent) {
      if (e.key === "Escape") setModalOpen(false);
      else if (e.key === "ArrowLeft") setModalIndex((i) => (i > 0 ? i - 1 : imageData.length - 1));
      else if (e.key === "ArrowRight") setModalIndex((i) => (i < imageData.length - 1 ? i + 1 : 0));
      else if (e.key === "+" || e.key === "=") zoomIn();
      else if (e.key === "-") zoomOut();
      else if (e.key === "0") resetView();
    }
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [modalOpen, imageData.length]);
  /**
   *
   * @param files
   */
  function handleChangeDropFile(files: any) {
    if (files.length !== 0) {
      handleChangeFiles(files);
      const images = [] as any;
      files.forEach((file: any) => {
        const reader = new FileReader();
        if (file.type.match("image.*")) {
          reader.readAsDataURL(file);
          reader.onloadend = function () {
            setImageData((prev: any[]) => [
              ...prev,
              {
                path: reader.result,
                name: file.name,
              },
            ]);
            setDropzoneFiles(images);
          };
        }
      });
    }
  }
  /**
   *
   * @param index
   */
  function deleteImage(index: any) {
    const imageToDelete = imageData[index];
    const newImageList = imageData.slice() as any;
    let newFileList = [];

    // If it's an external URL, just remove it from the array
    // No need to search for it in local files
    if (imageToDelete?.isExternalUrl) {
      setImageData((prev: any[]) => prev.filter((_, i) => i !== index));
      newImageList.splice(index, 1);
      handleDeleteImages(newImageList, files, index);
    } else {
      // Handle local files as before
      if (files) {
        setImageData((prev: ImageData[]) => prev.filter((_, i) => i !== index));
        newFileList = files.slice() as any;
        const fileIndex = newFileList.findIndex(
          (file: any) => file.name === newImageList[index].name
        );
        if (fileIndex >= 0) newFileList.splice(fileIndex, 1);
      }
      newImageList.splice(index, 1);
      handleDeleteImages(newImageList, newFileList, index);
    }
  }

  const token = localStorage.getItem("access_token");
  let axiosConfig = {} as any;
  if (token) {
    axiosConfig = {
      responseType: "blob",
      headers: {
        Authorization: `Bearer ${token}`,
        "cache-control": "no-cache",
      },
    };
  }

  /**
   * Check if a string is a web URL
   */
  function isWebUrl(str: string): boolean {
    return str.startsWith("http://") || str.startsWith("https://");
  }

  useEffect(() => {
    if (images.length > 0 && shouldUpdate) {
      images.map(async (image) => {
        // If the image is already a web URL, use it directly
        if (isWebUrl(image)) {
          setImageData((prev: any[]) => [
            ...prev,
            {
              path: image,
              name: image.split("/").pop() || "image",
              isExternalUrl: true,
            },
          ]);
        } else {
          // Fetch the image from the backend
          try {
            const imageUrl = `${urlEnum.products}/getImage/productsImages/${encodeURIComponent(image)}`;
            const img = await axios.get(imageUrl, axiosConfig);
            const url = URL.createObjectURL(img.data);
            setImageData((prev: any[]) => [
              ...prev,
              {
                path: url,
                name: img.data?.name,
                isExternalUrl: false,
              },
            ]);
          } catch (error) {
            console.error("Error fetching image:", error);
          }
        }
        setShouldUpdate(false);
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [images]);
  /**
   *
   */
  function showImages() {
    displayDropzoneImages([...images, ...dropzoneFiles]);
    setDropzoneFiles([]);
    setShowDropzone(false);
  }
  const thumbnails = (
    <div className={styles.displayImagesContainer}>
      {imageData.map((image: any, index: any) => {
        return (
          <div
            key={`image_${index}`}
            className={
              isSmall ? styles.displayImagesSmall : styles.displayImages
            }
          >
            {handleCheckImages && handleCheckImages ? (
              <Checkbox
                checked={checkedImages.includes(index) ? true : false}
                onChange={() => handleCheckImages(index)}
                className={styles.checkboxImagesBtn}
                style={{ color: theme.palette.primary.main }}
              />
            ) : null}
            <IconButton
              className={styles.deleteImagesBtn}
              onClick={() => deleteImage(index)}
            >
              <DeleteIcon />
            </IconButton>
            <img
              src={image.path}
              alt="preview"
              style={{ height: "100%", cursor: "pointer" }}
              onClick={() => openModal(index)}
            />
          </div>
        );
      })}
    </div>
  );

  const lightbox = (
    <Modal open={modalOpen} onClose={() => setModalOpen(false)}>
      <Box sx={{ position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)", width: "90vw", height: "90vh", bgcolor: "background.paper", boxShadow: 24, borderRadius: 2, display: "flex", flexDirection: "column", overflow: "hidden" }}>
        {/* Header */}
        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", px: 1, py: 0.5, borderBottom: "1px solid #ddd", flexShrink: 0 }}>
          <Box sx={{ fontSize: 14, color: "text.secondary" }}>{modalIndex + 1} / {imageData.length}</Box>

          {/* Zoom controls: - R + */}
          <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
            <Tooltip title="Zoom out  (-)">
              <span>
                <IconButton size="small" onClick={zoomOut} disabled={zoom <= ZOOM_MIN}>
                  <RemoveIcon fontSize="small" />
                </IconButton>
              </span>
            </Tooltip>
            <Tooltip title="Reset  (0)">
              <span>
                <IconButton size="small" onClick={resetView} disabled={zoom === 1 && pan.x === 0 && pan.y === 0}>
                  <RestartAltIcon fontSize="small" />
                </IconButton>
              </span>
            </Tooltip>
            <Tooltip title="Zoom in  (+)">
              <span>
                <IconButton size="small" onClick={zoomIn} disabled={zoom >= ZOOM_MAX}>
                  <AddIcon fontSize="small" />
                </IconButton>
              </span>
            </Tooltip>
            <Box sx={{ fontSize: 12, color: "text.secondary", minWidth: 36, textAlign: "center" }}>
              {Math.round(zoom * 100)}%
            </Box>
          </Box>

          <IconButton onClick={() => setModalOpen(false)} size="small"><CloseIcon /></IconButton>
        </Box>

        {/* Image area */}
        <Box
          sx={{ flex: 1, display: "flex", alignItems: "center", justifyContent: "center", position: "relative", bgcolor: "#000", overflow: "hidden", cursor: zoom > 1 ? "grab" : "default", userSelect: "none" }}
          onMouseDown={onMouseDown}
          onMouseMove={onMouseMove}
          onMouseUp={onMouseUp}
          onMouseLeave={onMouseUp}
        >
          {imageData[modalIndex] && (
            <img
              src={imageData[modalIndex].path}
              alt={`Photo ${modalIndex + 1}`}
              draggable={false}
              style={{
                transform: `translate(${pan.x}px, ${pan.y}px) scale(${zoom})`,
                transformOrigin: "center center",
                transition: dragging.current ? "none" : "transform 0.15s ease",
                maxWidth: "100%",
                maxHeight: "100%",
                objectFit: "contain",
                display: "block",
                pointerEvents: "none",
              }}
            />
          )}
          {imageData.length > 1 && (
            <>
              <IconButton onClick={() => setModalIndex((i) => (i > 0 ? i - 1 : imageData.length - 1))} sx={{ position: "absolute", left: 16, top: "50%", transform: "translateY(-50%)", bgcolor: "rgba(255,255,255,0.8)", "&:hover": { bgcolor: "rgba(255,255,255,0.9)" } }}>
                <ArrowBackIosNewIcon />
              </IconButton>
              <IconButton onClick={() => setModalIndex((i) => (i < imageData.length - 1 ? i + 1 : 0))} sx={{ position: "absolute", right: 16, top: "50%", transform: "translateY(-50%)", bgcolor: "rgba(255,255,255,0.8)", "&:hover": { bgcolor: "rgba(255,255,255,0.9)" } }}>
                <ArrowForwardIosIcon />
              </IconButton>
            </>
          )}
        </Box>
      </Box>
    </Modal>
  );

  if (inline) {
    return (
      <>
        <DropzoneComponent
          onSave={(files: any) => handleChangeDropFile(files)}
          maxFiles={maxFiles}
        />
        {imageData.length > 0 && thumbnails}
        {lightbox}
      </>
    );
  }

  return (
    <>
      {showDropzone ? (
        <div style={{ marginTop: 20 }}>
          <DropzoneComponent
            onSave={(files: any) => handleChangeDropFile(files)}
            maxFiles={maxFiles}
          />
          <Button
            variant="contained"
            size="large"
            className={styles.showImagesBtn}
            onClick={showImages}
            style={{ color: "white" }}
          >
            {Vocabulary.finish}
          </Button>
        </div>
      ) : (
        <>
          <Button
            variant="contained"
            size="medium"
            style={{ marginTop: 20, marginBottom: 10, color: "white" }}
            onClick={() => setShowDropzone(true)}
          >
            <CloudUpload
              fontSize="medium"
              style={{
                marginRight: 10,
              }}
            />
            {Vocabulary.attachFiles}
          </Button>
          <div>{thumbnails}</div>
        </>
      )}
      {lightbox}
    </>
  );
}
